import { put } from "redux-saga/effects";
import { Types } from "../actionTypes";

export function* getUserLocation(action) {
  try {
    console.log("UserLocationSaga, getLocation");
    // const data = yield call(getCurrentPosition, action);
    // yield put({ type: FETCHING_USERLOCATION_SUCCESS, data });
  } catch (e) {
    yield put({ type: Types.FETCHING_USERLOCATION_FAILURE });
    console.log("error" + e);
  }
}
